import React, { useState } from 'react';

import { Icon } from 'assets/icons';
import { useContentJobService } from 'hooks/api/agents/content/content-job';
import { ContentJobViewPage } from '../../../jobs/view';
import styles from './channel.module.css';

export const ChannelReviewPanel = ({
  blog_id,
  blog_status,
  agent_type,
  channel_label = '',
  content_job = null,
  loading = false,
  refresh_key = 0,
  onJobsChange = () => {}
}) => {
  const { triggerContentAgentRun } = useContentJobService();
  const [triggering, setTriggering] = useState(false);

  const handleRun = async () => {
    setTriggering(true);
    const success = await triggerContentAgentRun(agent_type, blog_id);
    if (success) await onJobsChange();
    setTriggering(false);
  };

  if (loading) {
    return <div className={styles.placeholder}>Loading {channel_label.toLowerCase()} draft…</div>;
  }

  if (content_job) return <ContentJobViewPage job_id={content_job.id} refresh_key={refresh_key} />;

  const is_published = blog_status === 'published';

  return (
    <div className={styles.emptyState}>
      <div className={styles.emptyIcon}>
        <Icon name="ai" width={22} height={22} />
      </div>
      <p className={styles.emptyTitle}>No {channel_label.toLowerCase()} draft yet</p>
      <p className={styles.emptyHint}>
        {is_published
          ? 'The agent has not produced a draft for this post. Run it now to generate one.'
          : 'The agent runs automatically once this post is published to WordPress.'}
      </p>
      <button
        type="button"
        className={styles.runBtn}
        onClick={handleRun}
        disabled={triggering || !is_published}
      >
        {triggering ? 'Starting…' : `Run ${channel_label.toLowerCase()} agent`}
      </button>
    </div>
  );
};
